import { Dropdown } from 'react-bootstrap';
import * as React from 'react';
import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { DropdownToggle } from 'moduleBase/modules/menu-balance/components/DropdownToggle';
import { DropdownMenu } from 'moduleBase/modules/menu-balance/components/DropdownMenu';

const MenuBalanceDropdown = () => {
  const {
    isOpen,
    show,
    hide,
  } = useMenuBalanceContext();

  return (
    <Dropdown
      className="balance-dropdown"
      show={isOpen}
      onToggle={(isOpenLocal, event, metadata) => {
        if (metadata.source === 'rootClose') {
          hide();
        } else {
          show();
        }
      }}
    >
      <DropdownToggle isOpen={isOpen} />
      <DropdownMenu />
    </Dropdown>
  );
};

export { MenuBalanceDropdown };
